// extracted by mini-css-extract-plugin
export default {"flexContainer":"DeviceEntry_flexContainer__k6SOm","flexItemRight":"DeviceEntry_flexItemRight__tXO2C"};